
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/Lachenschmid/[[...slug]]",
      function () {
        return require("private-next-pages/_sites/Lachenschmid/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/Lachenschmid/[[...slug]]"])
      });
    }
  